import { Box, Text } from '@chakra-ui/react';

export function CartLineItemTitle({
  title,
  subtitle,
  isPreorder = false,
}: {
  title: string;
  subtitle: string;
  isPreorder?: boolean;
}) {
  return (
    <Box>
      <Text size="title2" as="h2">
        {title}
      </Text>
      <Text size="title2" color="blackAlpha.700">
        {isPreorder ? 'Pre-order' : subtitle}
      </Text>
    </Box>
  );
}
